import { LogType, RemoteLogger } from '@frontend/vanilla/core';

export class SportsRemoteLogger {
    private loggerName: string | undefined;
    private readonly MS2_LOGGER_TOKEN = 'ms2logger';

    constructor(
        loggerName: string,
        private vanillaLogger: RemoteLogger,
    ) {
        const alphaNumeric = /^[a-zA-Z\d]+$/g;

        if (!loggerName || !alphaNumeric.test(loggerName)) {
            throw new Error(`Logger name should be alphanumeric for easy elasticsearch lookup`);
        }

        this.loggerName = loggerName;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error(error: any, additionalMessage?: string): void {
        if (!error) {
            return;
        }

        let resultError = error;

        if (typeof error === 'string') {
            resultError = new Error(error);
        }

        resultError.description = this.MS2_LOGGER_TOKEN;

        resultError.fileName = this.loggerName;

        this.vanillaLogger.logError(resultError, additionalMessage);
    }

    info(message: string): void {
        if (!message) {
            return;
        }

        const formattedMessage = [this.MS2_LOGGER_TOKEN, this.loggerName, message].filter(Boolean).join(' ');

        this.vanillaLogger.log(formattedMessage, LogType.Info);
    }

    warning(message: string): void {
        if (!message) {
            return;
        }

        const formattedMessage = [this.MS2_LOGGER_TOKEN, this.loggerName, message].filter(Boolean).join(' ');

        this.vanillaLogger.log(formattedMessage, LogType.Warning);
    }
}
